import React from 'react';

import { Button } from '../../../../elements';
import ModalContainer from '../../../../elements/ModalContainer/ModalContainer';
import modal from '../../../../elements/ModalContainer/ModalContainer.module.scss';
import { showError, showSuccess } from '../../../../elements/Toasts/toastActions';
import { logout } from '../../../../components/auth/redux/authActions';
import { webhookActions } from '../../../../redux/reducers/webhook';
import { modalState } from '../../../../redux/reducers/webhooks';
import { useAppSelector, useAppDispatch } from '../../../../hooks/useRedux';
import settings from '../../../../pages/apps/Settings.module.scss';
import strings from '../../../../lang/lang';

interface IModal {
  closeModal: (v?: object) => any;
}

function DeleteCertificate(props: IModal) {
  const { closeModal } = props;
  const dispatch = useAppDispatch();
  const modalData = useAppSelector(modalState);

  function deleteCertificate() {
    return new Promise((res, rej) => {
      const id = modalData.id;
      dispatch(webhookActions.deleteWebhookCertificate({ id, res, rej }));
    })
    .then(() => {
      showSuccess(strings.appWebhookDetails.text.successCertificateDelete);
    })
    .catch(({ data, status }) => {
      if (status === 401) {
        logout();
      }
      showError(strings.appWebhookDetails.errors.deletingCertificateException);
    });
  }

  return (
    <ModalContainer
      isOpen
      closeModalWindow={() => closeModal({})}
      title={strings.appWebhookDetails.text.deleteCertificateTitle}
    >
      <div className={modal['react-modal__btn-box']}>
        <div className={settings.settings__info_text}>
          <strong>
            {strings.appWebhookDetails.text.deleteCertificateQuestion}
            <br /> {'deleteCertificateName'}?{' '}
          </strong>
          <p>{strings.appWebhookDetails.text.deleteCertificateDescription}</p>
        </div>
        <Button
          name={strings.appWebhookDetails.buttons.deleteCertificate}
          variant="primary"
          secondaryClassName="popup_primary"
          className="revoke"
          type="submit"
          onClick={() => {
            deleteCertificate();
            closeModal({});
          }}
        />
      </div>
      <Button
        name={strings.appWebhookDetails.buttons.cancel}
        variant="secondary"
        secondaryClassName="popup_secondary"
        type="submit"
        onClick={() => closeModal({})}
      />
    </ModalContainer>
  );
}

export default DeleteCertificate;
